<div class="dropdown" dropdown #dropdown="bs-dropdown">
    <!-- Dropdown open button with a globe icon  -->
    <button id="language-select-dropdown-btn" dropdownToggle type="button" class="btn btn-link dropdown-toggle"
       aria-controls="language-select-dropdown-list">
    <img *ngIf="currentLanguage == 'fi'" height="24px" src="assets/lang/fi.svg" alt="FIN">
    <img *ngIf="currentLanguage == 'se'" height="24px" src="assets/lang/sv.svg" alt="SVE">
    <img *ngIf="currentLanguage == 'en'" height="24px" src="assets/lang/en.svg" alt="ENG">

    </button>
    <!-- Dropdown list of available languages -->
    <ul class="dropdown-menu dropdown-menu-right px-3 shadow-sm" *dropdownMenu role="menu">
        <li *ngFor="let language of languages">
            <button type="button" class="dropdown-item" (click)="changeLanguage(language.value)">
                <img *ngIf="language.value == 'fi'" height="24px" src="assets/lang/fi.svg" alt="FIN">
                <img *ngIf="language.value == 'se'" height="24px" src="assets/lang/sv.svg" alt="SVE">
                <img *ngIf="language.value == 'en'" height="24px" src="assets/lang/en.svg" alt="ENG">
                {{language.name}}
            </button>
        </li>
    </ul>
</div>
